<template>
    <v-card
      class="ma-0 pa-3 position-relative"
      height="342"
    >
        <v-container
            class="pa-0 d-flex justify-space-between align-center mb-4 position-static"
        >
            <v-card-text class="pa-0 text-body-2">{{ $t('debtor-customers') }}</v-card-text>
            <v-btn
              color=""
              outlined
              custom
              @click="goto"
            >
            {{ $t('see-all') }}
            </v-btn>
        </v-container>
        <div
          v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview')"
          ref="scrollContainer"
          class="wrapper"
        >
            <v-list
                v-if="items != null && items != undefined && items.length >  0"
                class="pa-0"
            >
                <v-list-item
                    v-for="(item, index) in items"
                    :key="index"
                    class="pa-0"
                >
                    <v-list-item-content class="pa-0">
                        <v-container
                            class="pa-0 d-flex justify-space-between align-center"
                        >
                            <v-container
                                class="pa-0 ma-0 d-flex align-center gap-2"
                            >
                                <img
                                  @click="edit(item)"
                                  style="cursor: pointer;"
                                  :src="(item.avatar != null && item.avatar.link != null) ? item.avatar.link : require('@/assets/Avatar.png')" 
                                />
                                <v-container
                                    class="pa-0"
                                >
                                    <v-container class="pa-0 d-flex align-center gap-1">
                                        <v-card-text class="pa-0 text-caption">#{{ item.user_id ? item.user_id : '' }}</v-card-text>
                                        <v-card-text
                                          @click="edit(item)"
                                          style="cursor: pointer;"
                                          class="pa-0 text-caption"
                                        >
                                        {{ item.name }}
                                        </v-card-text>
                                    </v-container>
                                    <v-card-text class="pa-0 text-caption text--disabled">{{ item.mobile ? item.mobile : '-' }}</v-card-text>
                                </v-container>
                            </v-container>
                            <v-container
                                class="pa-0 ma-0 d-flex align-center gap-2"
                            >
                                <v-card-text class="pa-0 text-caption">{{ $numberFormat(item.remain.remain) }} {{ $store.state.currency.name }}</v-card-text>
                            </v-container>
                        </v-container>
                        <v-divider class="my-2" />
                    </v-list-item-content>
                </v-list-item>
                <v-container
                  v-if="loadingPaginate"
                  class="text-center pa-2"
                >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      :width="3"
                    />
                </v-container>
            </v-list>
            <div
              v-if="items != null && items != undefined && items.length == 0 && !loading"
              style="margin-top: 50px;"
            >
              <div class="d-flex justify-center align-center">
                <img src="@/assets/dashboard/no-data(3).png" style="width: 150px;height: 60px;" />
              </div>
              <div class="d-flex justify-center align-center mt-5">
                <v-card-text class="pa-0 text-caption">
                  {{ $t('there is no enough information for showing.') }}
                </v-card-text>
              </div>
            </div>
            <v-container
              v-if="loading"
              class="pa-0 d-flex justify-center align-center"
            >
              <v-progress-circular
                :width="3"
                color="blue"
                indeterminate
              />
            </v-container>
        </div>
        <div v-else>
          <div
            style="margin-top: 50px;"
          >
            <div class="d-flex justify-center align-center">
              <img src="@/assets/dashboard/not-access(2).png" style="width: 150px;height: 60px;" />
            </div>
            <div class="d-flex justify-center align-center mt-5">
              <v-card-text class="pa-0 text-caption text-center">
                {{ $t("you don't have access to this information") }}
              </v-card-text>
            </div>
        </div>
        </div>
    </v-card>
</template>

<script>
export default {
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: []
      },
      items: [],
      loading: false,
      loadingPaginate: false,
      lastPage: null
    }
  },
  methods: {
    fetchList () {
      if (this.items.length == 0) {
        this.loading = true
      }
      this.$axios.get(this.$endpoint + 'customer/show', {
        params: {
          page: this.options.page,
          options: JSON.stringify({ page: this.options.page, itemsPerPage: this.options.itemsPerPage }),
          status: 'active',
          remainStatus: '>'
        }
      })
        .then(r => {
          this.loading = false
          this.loadingPaginate = false
          const newData = r.data.data.filter(item => item.remain != null && item.remain.remain != 0 && item.remain.remain > 0)
          if (newData.length > 0) {
            this.items.push(...newData)
          }
          this.lastPage = r.data.last_page
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleScroll () {
      const container = this.$refs.scrollContainer
      if (!container) return
      const scrollHeight = container.scrollHeight // Total scrollable height
      const scrollTop = container.scrollTop // How much is scrolled
      const clientHeight = container.clientHeight // Visible height
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        if (this.options.page < this.lastPage) {
          this.loadingPaginate = true
          this.options.page++
          this.fetchList()
        }
      }
    },
    goto () {
      this.$router.push('/debtor/list')
    },
    edit (item) {
      this.$router.push({ name: 'customerEdit', params: { id: item.id } })
    }
  },
  mounted () {
    this.fetchList()
    this.$nextTick(() => {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll)
      }
    })
  },
  beforeDestroy () {
    this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
.container,
.v-card__text {
    width: auto;
}
img {
    width: 36px;
    height: 36px;
    border-radius: 4px;
}
.position-relative {
    position: relative;
}
.position-static {
    position: static;
}
.wrapper {
    height: 269px;
    overflow: auto;
}
.wrapper::-webkit-scrollbar {
  display: none;
}
.v-btn--outlined {
    border: thin solid #c0c0c09e;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
</style>
